export default __webpack_public_path__ + "static/media/meller-rechtsanwalt-immobilienrecht.2f444207.svg";